import React, { useEffect, useState } from "react";
import { getActiveJob, applyJob, saveJob } from "../../../service/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ActiveJob = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(null);
  // const [btnloading, setBtnLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopCategories = async () => {
      try {
        const response = await getActiveJob();
        const data = response.data.data;
        setCategories(data);

        if (data.length > 0) setActiveTab(data[0].categoryId); // default first tab
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopCategories();
  }, []);

  const [loadingJobId, setLoadingJobId] = useState(null);

  const handleApply = async (jobId) => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token) {
      navigate("/jobseeker/login", {
        state: { from: window.location.pathname },
      });
      return;
    }

    if (role !== "job_seeker") {
      toast.error("Only jobseekers can apply for jobs!");
      return;
    }

    try {
      setLoadingJobId(jobId);
      const res = await applyJob({ jobPostId: jobId });
      toast.success(res.data.message || "Job applied successfully!");
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to apply for job."
      );
    } finally {
      setLoadingJobId(null);
    }
  };

  const [savedJobs, setSavedJobs] = useState([]);
  const [loadingSavedJobId, setLoadingSavedJobId] = useState(null);

  const handleSaveJob = async (jobId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/jobseeker/login", {
        state: { from: window.location.pathname },
      });
      return;
    }

    try {
      setLoadingSavedJobId(jobId);
      await saveJob(jobId);
      setSavedJobs((prev) =>
        prev.includes(jobId)
          ? prev.filter((id) => id !== jobId)
          : [...prev, jobId]
      );
      toast.success("Job saved successfully!");
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to save job."
      );
    } finally {
      setLoadingSavedJobId(null);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!categories.length) return null;

  return (
    <section className="featuredjobs pt-50 pb-50">
      <div className="site-width">
        <div className="titleSection text-center wow animate__fadeInDown position-relative z-3">
          <h2>Active openings for you</h2>
          {/* <p>Find the right career opportunity for you</p> */}
        </div>

        <nav className="joblistNav wow animate__fadeInLeft">
          <div className="nav nav-tabs mb-3" role="tablist">
            {categories.map((fcList, index) => (
              <button
                key={fcList.categoryId}
                className={`nav-link ${
                  activeTab === fcList.categoryId ? "active" : ""
                }`}
                onClick={() => setActiveTab(fcList.categoryId)}
              >
                {fcList.categoryName}
              </button>
            ))}
          </div>
        </nav>

        <div className="jobListWrapper position-relative z-3">
          <div className="tab-content">
            {categories
              .filter((category) => category.categoryId === activeTab) // render only active tab
              .map((category) => (
                <div
                  key={category.categoryId}
                  className="tab-pane fade show active"
                  id={category.categoryId}
                >
                  <div className="listWrap">
                    <div className="row">
                      {category.jobPost.map((job) => (
                        <div
                          className="col-md-4 animate__animated animate__zoomIn"
                          key={job._id}
                        >
                          <div className="astrocard position-relative">
                            <div
                              className="dropdown"
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                              }}
                            >
                              <button
                                className="btn btn-light btn-sm"
                                type="button"
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  fontSize: "20px",
                                  color: "#eb642d",
                                }}
                                onClick={() => handleSaveJob(job._id)}
                                disabled={loadingSavedJobId === job._id}
                              >
                                {loadingSavedJobId === job._id ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : savedJobs.includes(job._id) ? (
                                  <i className="fa-solid fa-bookmark"></i>
                                ) : (
                                  <i className="fa-regular fa-bookmark"></i>
                                )}
                              </button>
                            </div>
                            <div className="astrocContainer">
                              <div className="astrohead">
                                <div className="astroImg">
                                  <a href="#">
                                    <img
                                      src={
                                        job.companyImage ||
                                        "/assets/img/company-profiles/image-1.png"
                                      }
                                      alt="img"
                                    />
                                  </a>
                                </div>
                              </div>

                              <div className="astroDetails">
                                <div className="astroName">
                                  <a href={`/job-details/${job._id}`}>
                                    <h4>
                                      {job.jobTitle?.length > 20
                                        ? job.jobTitle.slice(0, 20) + "..."
                                        : job.jobTitle}{" "}
                                      <img
                                        src="/assets/img/icons/icon-bold.svg"
                                        className="verifiedCheck"
                                        alt="icon"
                                      />
                                    </h4>
                                  </a>

                                  <ul className="astroAcheiver companyName">
                                    <li>
                                      <img
                                        src="assets/img/icons/office.svg"
                                        width="20"
                                        alt="icon"
                                      />
                                      <p>{job.company}</p>
                                    </li>
                                  </ul>

                                  <div className="astroinfo">
                                    <li>
                                      <img
                                        src="assets/img/icons/location-.svg"
                                        alt="icon"
                                      />
                                      <span>{job.city}</span>
                                    </li>
                                    <li>
                                      <img
                                        src="assets/img/icons/calender.svg"
                                        alt="icon"
                                      />
                                      <span>{job.jobPosted}</span>
                                    </li>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="astrolBtns flex-wrap">
                              {job.skills.map((skill, idx) => (
                                <a
                                  href="javascript:void(0)"
                                  className="astrocatbadge"
                                  key={idx}
                                >
                                  {skill}
                                </a>
                              ))}
                            </div>

                            <div className="d-flex gap-2 align-item-center w-100 joblistfooter">
                              <span
                                style={{ height: "fit-content" }}
                                className="joblistrate"
                              >
                                <img
                                  src="/assets/img/icons/time.svg"
                                  alt="img"
                                  style={{ width: "20px" }}
                                />
                                ₹{job.minSalary} - ₹{job.maxSalary} (
                                {job.salaryType}).
                              </span>
                            </div>

                            <div className="d-flex joblistfooter">
                              <a
                                href={`/job-details/${job._id}`}
                                className="mainbtn"
                                style={{
                                  backgroundColor: "#270b79",
                                  border: "1px solid #270b79",
                                }}
                              >
                                View Details
                              </a>
                              &nbsp;
                              <button
                                className="mainbtn"
                                onClick={() => handleApply(job._id)}
                                disabled={loadingJobId === job._id}
                              >
                                {loadingJobId === job._id ? (
                                  <span>
                                    <i
                                      className="fa fa-spinner fa-spin"
                                      style={{ marginRight: "8px" }}
                                    ></i>
                                    Applying...
                                  </span>
                                ) : (
                                  "Apply Now"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="seeallbtnwrap text-center mt-4 wow animate__fadeInUp">
          <a href="/job-list" className="outlineBtn">
            See More Jobs <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ActiveJob;
